import { IObservable, SeenTracker, Subject } from '~/rage/utils';
import {
	IClientConfigs,
	IVehicleShopInfo,
	IVehicleShopOffer,
	RgbColor,
	VehicleShopType,
	WalletType,
} from '~/shared';
import { IVehicleShopService } from './vehicleShopServiceTypes';

export class VehicleShopServiceStub implements IVehicleShopService {
	private seenTracker = new SeenTracker(null);

	private shopInfo = new Subject<IVehicleShopInfo | null>({
		id: VehicleShopType.LOW,
		name: 'Элитный автосалон',
		title: 'Luxury cars',

		maxFuelTankCapacity: 2000,
		maxTrunkVolume: 50000,
		maxVehicleSpeed: 500,

		testDriveDurationSec: 60,

		vehicles: [],
	});
	private numberPlatesRegions = new Subject<
		IClientConfigs['vehicleNumberPlates']['regions']
	>([]);
	private vehicleShopOffer = new Subject<IVehicleShopOffer | null>({
		title: 'Специальное предложение',
		description: 'Купите автомобиль и получите',
		caseId: '123',
		color: '#ffaabb',
	});

	constructor() {
		const regions = [];
		for (let i = 0; i < 100; i++) {
			regions.push({
				code: (i + 1).toString(),
				name: 'Московская область',
			});
		}
		this.numberPlatesRegions.next(regions);

		const vehicleModels = {
			bmwm8: 'bmwm8',
			dbs2009: 'dbs2009',
			mgrantur2010: 'mgrantur2010',
			por911gt3: 'por911gt3',
			r8v10: 'r8v10',
			g500: 'g500',
			e63s: 'e63s',
			x6f86: 'x6f86',
			g30: 'g30',
			x6f16: 'x6f16',
		};

		const shopVehicles = Object.entries(vehicleModels).map(([model, name]) => {
			const onlyCase = Math.random() > 0.8;

			return {
				name,
				model,
				priceCash: 9000000,
				priceDonate: 10000,
				priceTestDrive: 90000,
				specs: {
					fuelTankCapacity: 1200,
					fuelConsumptionRate: 1.5,
					maxSpeed: 200,
					trunkVolume: 1000,
					passengerSeats: 4,
				},
				tags: {
					discount: onlyCase ? undefined : 50,
					onlyCase,
				},
				caseName: onlyCase ? 'Дарксайд' : undefined,
			};
		});

		const shopInfo = this.shopInfo.getValue()!;
		this.shopInfo.next({
			...shopInfo,
			vehicles: shopVehicles,
		});
	}

	public getShopInfo(): IObservable<IVehicleShopInfo | null> {
		return this.shopInfo;
	}

	public getNumberPlateRegions(): IObservable<
		IClientConfigs['vehicleNumberPlates']['regions']
	> {
		return this.numberPlatesRegions;
	}

	public async buyVehicle(
		id: string,
		color: [RgbColor, RgbColor],
		wallet: WalletType,
	): Promise<void> {
		console.log('buyVehicle', { id, color, wallet });
	}

	public async testDriveVehicle(
		id: string,
		color: [RgbColor, RgbColor],
	): Promise<void> {
		console.log('testDriveVehicle', { id, color });
	}

	public async exitShop(): Promise<void> {
		console.log('exit');
	}

	public async setPreviewVehicleModel(model: string | null): Promise<void> {
		console.log('setPreviewVehicleModel', { model });
	}

	public async setPreviewVehicleColor(
		color: [RgbColor, RgbColor],
	): Promise<void> {
		console.log('setPreviewVehicleColor', { color });
	}

	public isUnseen(path: string): boolean {
		return this.seenTracker.isUnseen(path);
	}

	public markSeen(path: string): void {
		console.log('vehicleShop:markSeen', path);
		this.seenTracker.markAsSeen(path);
	}

	public getVehicleShopOffer(): IObservable<IVehicleShopOffer | null> {
		return this.vehicleShopOffer;
	}
}
